import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_DETECTION_LINK_DATA,
  INCIDENT_DETAILS_SET_DETECTION_LINK_COMMON_LINK_DATA,
  INCIDENT_DETAILS_SET_DETECTION_LINK_IMAGES,
  INCIDENT_DETAILS_SET_DETECTION_LINK_MULTIMEDIA_FILE,
  INCIDENT_DETAILS_SET_DETECTION_LINK_OFFER_LISTING,
  INCIDENT_DETAILS_SET_DETECTION_LINK_OVERALL_MULTIMEDIA,
  INCIDENT_DETAILS_SET_DETECTION_LINK_PRICE_LIST,
  INCIDENT_DETAILS_SET_DETECTION_LINK_PRODUCT_LISTING,
  INCIDENT_DETAILS_SET_DETECTION_LINK_SOCIAL_MEDIA_LINK_DATA,
} from '../../../../actions/actionTypes';
import { getLinkDataStateCopy } from '../incidentDetailsHelpers';

export const additionalActionsReducer = (state, action) => {
  switch (action.type) {
    case INCIDENT_DETAILS_SET_DETECTION_LINK_COMMON_LINK_DATA: {
      const stateCopy = getLinkDataStateCopy(state);
      stateCopy.data.commonLinkData = action.payload.commonLinkData;

      return stateCopy;
    }

    case INCIDENT_DETAILS_SET_DETECTION_LINK_IMAGES: {
      const stateCopy = getLinkDataStateCopy(state);
      stateCopy.data.linkImageList = action.payload.images;

      return stateCopy;
    }

    case INCIDENT_DETAILS_SET_DETECTION_LINK_MULTIMEDIA_FILE: {
      const stateCopy = getLinkDataStateCopy(state);
      stateCopy.data.multimediaFileLinkData = action.payload.multiMediaFile;

      return stateCopy;
    }

    case INCIDENT_DETAILS_SET_DETECTION_LINK_OFFER_LISTING: {
      const stateCopy = getLinkDataStateCopy(state);
      stateCopy.data.offerListingLinkData = action.payload.offerListing;

      return stateCopy;
    }

    case INCIDENT_DETAILS_SET_DETECTION_LINK_OVERALL_MULTIMEDIA: {
      const stateCopy = getLinkDataStateCopy(state);
      stateCopy.data.overallMultimediaLinkData =
        action.payload.overallMultimedia;

      return stateCopy;
    }

    case INCIDENT_DETAILS_SET_DETECTION_LINK_PRICE_LIST: {
      const stateCopy = getLinkDataStateCopy(state);
      stateCopy.data.linkPriceList = action.payload.priceList;

      return stateCopy;
    }

    case INCIDENT_DETAILS_SET_DETECTION_LINK_PRODUCT_LISTING: {
      const stateCopy = getLinkDataStateCopy(state);
      stateCopy.data.productListingLinkData = action.payload.productListing;

      return stateCopy;
    }

    case INCIDENT_DETAILS_SET_DETECTION_LINK_SOCIAL_MEDIA_LINK_DATA: {
      const stateCopy = getLinkDataStateCopy(state);
      stateCopy.data.socialMediaLinkData = action.payload.socialMedia;

      return stateCopy;
    }

    default:
      return state;
  }
};

const detectionLinkData = fetchReducerGenerator(
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_DETECTION_LINK_DATA,
  additionalActionsReducer
);

export default detectionLinkData;
